// Measured body bounding boxes inside each /public/anatomy/atlas/*.png.
//
// The atlas PNGs have inconsistent whitespace — some bodies sit on the left
// half, some on the right, some are centred with huge margins. Trigger-point
// coordinates in muscleAtlas.js, however, are authored as 0–100 % over the
// BODY itself. We use these bounds to crop & scale each image so the body
// fills the full anatomy stage; then the SVG overlay (viewBox 0 0 100 200)
// maps 1-for-1 to the body, and trigger points naturally land on the right
// muscles.
//
// Values were extracted with PIL/numpy (alpha + brightness threshold) from the
// production atlas files. Recompute if the atlas PNGs are ever replaced.

export const BODY_ATLAS_BOUNDS = {
  anterior: {
    m: { left: 2.3,  top: 2.3, right: 40.5, bottom: 98.3, imgWidth: 896,  imgHeight: 768 },
    f: { left: 38.8, top: 3.8, right: 61.1, bottom: 98.2, imgWidth: 1408, imgHeight: 761 },
  },
  posterior: {
    m: { left: 8.7,  top: 3.1, right: 91.3, bottom: 97.3, imgWidth: 391, imgHeight: 768 },
    f: { left: 47.7, top: 3.6, right: 96.5, bottom: 97.1, imgWidth: 633, imgHeight: 768 },
  },
};

// Returns the CSS values needed to crop+scale an atlas image so the body fills
// a wrapping container that itself uses `aspectRatio: aspect`. The SVG overlay
// inside the container can then use viewBox 0..100 (x) × 0..100 (y) and have
// every coordinate map straight onto the visible body.
export function bodyStageGeometry(view, sex) {
  const b = (BODY_ATLAS_BOUNDS[view] && BODY_ATLAS_BOUNDS[view][sex]) ||
            BODY_ATLAS_BOUNDS.anterior.m;
  const bw = (b.right - b.left) / 100;   // 0..1 — body width as fraction of image width
  const bh = (b.bottom - b.top) / 100;   // 0..1 — body height as fraction of image height
  const aspect = ((b.right - b.left) * b.imgWidth) /
                 ((b.bottom - b.top) * b.imgHeight);
  return {
    aspect,                                     // container aspect-ratio (≈ 0.44 for humans)
    imgStyle: {
      position: "absolute",
      width:  `${100 / bw}%`,
      height: `${100 / bh}%`,
      left:   `${-b.left / bw}%`,
      top:    `${-b.top  / bh}%`,
      maxWidth: "none",                         // override Tailwind base img maxWidth
      pointerEvents: "none",
      userSelect: "none",
    },
  };
}
